<div id="layer1" class="pop_layer md">
	<div class="dimbg"></div>
	<div class="pop_container">
		<div class="pop_conts">
			<p class="ctit text-center no_fix">
				Order Summary
			</p>
			<p class="order-summary text-center">
				<span>{{product.SKUDESC}}</span><br/>
				<span class="detail">Additional {{product.TERM}}-months coverage</span>
			</p>
			
			<div class="order-summary">
				<table>
					<tbody>
						<tr>
							<th>Price</th>
							<td class="text-right">{{price}}</td>
						</tr>
						<tr>
							<th>Tax({{taxrate}}%)</th>
							<td class="text-right">{{tax}}</td>
						</tr>
					</tbody>
				</table>
				<h3 class="result text-center">$ {{total}} / <span>{{this.shared.product.PAYMENTFREQUENCY}}</span></h3>
			</div>
			<div class="btn_area">
				<a class="btn btn_type2 btn_layerclose" (click)="onCancel()">Cancel</a>
				<a class="btn btn_type1 btn_layerclose" (click)="onConfirm()">Place Order<img src="./assets/images/button-arrow.png"></a>
			</div>
		</div>
	</div>
</div>